import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS, IsUndefinable, OrderFlowEnum, OrderGratuityTypeEnum, ReceiveMethodEnum } from '@goparrot/common';
import { ApiPropertyOptional } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDate, IsEnum, IsInstance, IsNotEmpty, IsNumber, IsString, MaxLength, ValidateNested } from 'class-validator';
import { CartExposeGroup } from '../../cart/interface';
import { OrderExposeGroup } from '../interface';
import { PatchDiningOptionInfoDto } from './PatchDiningOptionInfoDto';
import { PatchOrderAddressDto } from './PatchOrderAddressDto';
import { PatchOrderDateInfoDto } from './PatchOrderDateInfoDto';
import { PatchOrderDelayedInfoDto } from './PatchOrderDelayedInfoDto';
import { PatchOrderElementDto } from './PatchOrderElementDto';
import { PatchOrderETAReadyDto } from './PatchOrderETAReadyDto';
import { PatchOrderGiftCardElemDto } from './PatchOrderGiftCardElemDto';
import { PatchOrderPaymentInformationDto } from './PatchOrderPaymentInformationDto';
import { PatchOrderPromotionElementDto } from './PatchOrderPromotionElementDto';
import { PatchOrderRecipientDto } from './PatchOrderRecipientDto';
import { PatchOrderServiceChargeDto } from './PatchOrderServiceChargeDto';
import { PatchOrderTipsInfoDto } from './PatchOrderTipsInfoDto';
import { PatchOrderTotalAmountsDto } from './PatchOrderTotalAmountsDto';
import { PatchOrderVendorMathDto } from './PatchOrderVendorMathDto';
import { PatchOrderWeightDto } from './PatchOrderWeightDto';
import { PatchSchedulingInfoDto } from './PatchSchedulingInfoDto';
export class PatchNonPersistentCartDto {
    constructor() {
        this.giftcards = [];
    }
}
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "grossTotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "subtotal", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "total_discount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "total_tax", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "total_quantity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "total_gratuity", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "totalPosDelta", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "total", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'Refunded amount in cents', example: 100 }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "refundedAmount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderPaymentInformationDto }),
    Type(() => PatchOrderPaymentInformationDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderPaymentInformationDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderPaymentInformationDto)
], PatchNonPersistentCartDto.prototype, "paymentInformation", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderElementDto, isArray: true }),
    Type(() => PatchOrderElementDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(PatchOrderElementDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], PatchNonPersistentCartDto.prototype, "elements", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderPromotionElementDto, isArray: true }),
    Type(() => PatchOrderPromotionElementDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(PatchOrderPromotionElementDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], PatchNonPersistentCartDto.prototype, "promotions", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderGiftCardElemDto, isArray: true, default: [] }),
    Type(() => PatchOrderGiftCardElemDto),
    IsUndefinable({ always: true }),
    IsArray({ always: true }),
    IsInstance(PatchOrderGiftCardElemDto, { each: true, always: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], PatchNonPersistentCartDto.prototype, "giftcards", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, description: 'Gift cards total' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "giftCardsTotal", void 0);
__decorate([
    ApiPropertyOptional({ enum: OrderFlowEnum, example: OrderFlowEnum.REGULAR }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsEnum(OrderFlowEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchNonPersistentCartDto.prototype, "flow", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsUndefinable({ always: true }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchNonPersistentCartDto.prototype, "notes", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderAddressDto, description: 'Order address' }),
    Type(() => PatchOrderAddressDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderAddressDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderAddressDto)
], PatchNonPersistentCartDto.prototype, "address", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: false }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], PatchNonPersistentCartDto.prototype, "deliveryFee", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "deliveryFeeAmount", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderDelayedInfoDto }),
    Type(() => PatchOrderDelayedInfoDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderDelayedInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderDelayedInfoDto)
], PatchNonPersistentCartDto.prototype, "delayedInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderServiceChargeDto, isArray: true }),
    Type(() => PatchOrderServiceChargeDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsArray({ always: true }),
    IsInstance(PatchOrderServiceChargeDto, { always: true, each: true }),
    ValidateNested({ always: true, each: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Array)
], PatchNonPersistentCartDto.prototype, "serviceCharges", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    IsUndefinable({ always: true }),
    IsBoolean({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Boolean)
], PatchNonPersistentCartDto.prototype, "isAbandoned", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Time zone' }),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    MaxLength(500, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchNonPersistentCartDto.prototype, "tz", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderTipsInfoDto }),
    Type(() => PatchOrderTipsInfoDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderTipsInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderTipsInfoDto)
], PatchNonPersistentCartDto.prototype, "tipsInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderDateInfoDto }),
    Type(() => PatchOrderDateInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderDateInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderDateInfoDto)
], PatchNonPersistentCartDto.prototype, "dateInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderVendorMathDto }),
    Type(() => PatchOrderVendorMathDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderVendorMathDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderVendorMathDto)
], PatchNonPersistentCartDto.prototype, "math", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderRecipientDto }),
    Type(() => PatchOrderRecipientDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderRecipientDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderRecipientDto)
], PatchNonPersistentCartDto.prototype, "recipient", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderWeightDto }),
    Type(() => PatchOrderWeightDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderWeightDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderWeightDto)
], PatchNonPersistentCartDto.prototype, "weight", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchSchedulingInfoDto }),
    Type(() => PatchSchedulingInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchSchedulingInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchSchedulingInfoDto)
], PatchNonPersistentCartDto.prototype, "schedulingInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchDiningOptionInfoDto }),
    Type(() => PatchDiningOptionInfoDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchDiningOptionInfoDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchDiningOptionInfoDto)
], PatchNonPersistentCartDto.prototype, "diningOptionInfo", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Date tz', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    IsDate({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Date)
], PatchNonPersistentCartDto.prototype, "dateTz", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderETAReadyDto }),
    Type(() => PatchOrderETAReadyDto),
    IsUndefinable({ always: true }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderETAReadyDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderETAReadyDto)
], PatchNonPersistentCartDto.prototype, "ETAReady", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Fulfillment date tz', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    IsDate({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Date)
], PatchNonPersistentCartDto.prototype, "fulfillmentDateTz", void 0);
__decorate([
    ApiPropertyOptional({ enum: OrderGratuityTypeEnum, example: OrderGratuityTypeEnum.FIX }),
    IsUndefinable({ always: true }),
    IsEnum(OrderGratuityTypeEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchNonPersistentCartDto.prototype, "gratuity_type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number }),
    IsUndefinable({ always: true }),
    IsNumber({}, { always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Number)
], PatchNonPersistentCartDto.prototype, "gratuity_amount", void 0);
__decorate([
    ApiPropertyOptional({ enum: ReceiveMethodEnum, example: ReceiveMethodEnum.PICKUP }),
    IsUndefinable({ always: true }),
    IsEnum(ReceiveMethodEnum),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", String)
], PatchNonPersistentCartDto.prototype, "receive_method", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Fulfillment date', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], PatchNonPersistentCartDto.prototype, "date", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, format: 'date-time', description: 'Fulfillment date', example: '2019-10-29T11:29:56.853+0000' }),
    IsUndefinable({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", Object)
], PatchNonPersistentCartDto.prototype, "fulfillmentDate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => PatchOrderTotalAmountsDto, description: 'Various total sums of money in cents received' }),
    Type(() => PatchOrderTotalAmountsDto),
    IsUndefinable({ groups: [CartExposeGroup.PATCH, OrderExposeGroup.PATCH] }),
    IsNotEmptyObjectWithLVS({ always: true }),
    IsInstance(PatchOrderTotalAmountsDto, { always: true }),
    ValidateNested({ always: true }),
    Expose({
        groups: [CartExposeGroup.FIXTURE, CartExposeGroup.READ, CartExposeGroup.PATCH, OrderExposeGroup.FIXTURE, OrderExposeGroup.READ, OrderExposeGroup.PATCH],
    }),
    __metadata("design:type", PatchOrderTotalAmountsDto)
], PatchNonPersistentCartDto.prototype, "totalAmounts", void 0);
//# sourceMappingURL=PatchNonPersistentCartDto.js.map